import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { useDispatch, useSelector } from "react-redux";
import PatientLoader from "../../common/PatientLoader";
import CardLayout from "../../common/cardLayout/CardLayout";
import { InfoCard, NoPatients } from "../../pages/dashboard/DashboardHome";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/DownloadIcon.svg";
import { ReactComponent as PlusCircle } from "../../../assets/icons/plus-circle.svg";
import ClinicsTable from "./AllClinics/ClinicsTable";
import InvoicingHisotryTable from "./AllClinics/InvoicingHisotryTable";
import { fetchSingleClinicDataLogic } from "../../../store/features/ops/opsSlice";
import { getInitials } from "../../../util/helpers";
import moment from "moment";
import { isEmptyObject } from "jquery";

const SingleClinic = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [clinicID, setClinicID] = useState(parseInt(params?.clinicID));
  const { opsLoading, singleClinicData, healthcareGroups, allClinics } =
    useSelector((state) => state.ops);
  const [contractFile, setContractFile] = useState(null);
  const [autoCCMode, setAutoCCPayment] = useState(false);
  const [notes, setNotes] = useState(singleClinicData?.notes);
  const [clinicData, setClinicData] = useState({});
  const [relatedClinics, setRelatedClinics] = useState([]);
  const [isTestAccount, setIsTestAccount] = useState(false);
  const uploadContractInput = useRef();
  useEffect(() => {
    setClinicID(parseInt(params?.clinicID));
  }, [params]);

  useEffect(() => {
    if (clinicID) {
      dispatch(fetchSingleClinicDataLogic(clinicID));
    }
  }, [clinicID]);

  useEffect(() => {
    setIsTestAccount(clinicData?.is_test_account);
    setAutoCCPayment(clinicData?.auto_invoicing);
  }, [clinicData]);
  useEffect(() => {
    if (!isEmptyObject(singleClinicData)) {
      const temp = healthcareGroups.filter(
        (item) => item?.id === singleClinicData?.clinic_group
      );
      if (temp) setClinicData(temp[0]);
    }

    if (allClinics?.length > 0) {
      const temp = allClinics.filter(
        (item) => item.clinic_group === singleClinicData?.clinic_group
      );
      if (temp && temp?.length > 0) setRelatedClinics(temp);
    }
  }, [opsLoading]);

  const handleContractUpload = (e) => {
    if (e.target.files.length > 0) {
      setContractFile(e.target.files[0]);
    }
  };

  const removeContractFile = () => {
    if (contractFile) setContractFile(null);
  };

  return (
    <SidebarLayout>
      <section className="container-fluid w-100 p-5">
        {opsLoading ? (
          <PatientLoader />
        ) : (
          <>
            <div className="d-flex mt-3 mb-2">
              <div>
                <h3 className="primary-text-blue">{singleClinicData?.name}</h3>
                <Link to="/ops/home">
                  <span className="muted-text">
                    {"<"} Back to Clinic Healtcare Group
                  </span>
                </Link>
              </div>
            </div>
            <CardLayout
              className="container-fluid p-3 my-3"
              style={{ position: "relative" }}
            >
              <DownloadIcon
                title="Download this profile"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "20px",
                  cursor: "pointer",
                }}
              />

              <div
                className="row container-fluid w-100"
                style={{ margin: "0px", padding: "0px" }}
              >
                <div
                  className="col-sm-12 col-md-4 col-lg-4"
                  style={{ margin: "0px", padding: "0px" }}
                >
                  <div
                    className="d-flex container-fluid w-100 justify-content-evenly"
                    style={{ margin: "0px", padding: "0px" }}
                  >
                    <img
                      height="125px"
                      width="125px"
                      alt="User's DP"
                      style={{ borderRadius: "100%", padding: "0.2rem" }}
                      src={`https://placehold.co/125x125/f1f1f5/395E9D/?text=${getInitials(
                        singleClinicData?.name
                      )}`}
                    />
                    <div>
                      <div className="my-2">
                        <label>Name:</label>
                        <span className="muted-text">
                          {singleClinicData?.name}
                        </span>
                      </div>
                      <div className="my-2">
                        <label>Rose Sales Person:</label>
                        <span className="muted-text">
                          {singleClinicData?.rose_sales_team_member}
                        </span>
                      </div>
                      <div className="my-2">
                        <label>Billing Email:</label>
                        <span className="muted-text">
                          {singleClinicData?.email}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-sm-12 col-md-4 col-lg-4"
                  style={{
                    borderRight: "1px solid lightgray",
                    borderLeft: "1px solid lightgray",
                  }}
                >
                  <div className="my-2">
                    <label>Billing Contact No.:</label>
                    <span className="muted-text">
                      {clinicData?.contact_number}
                    </span>
                  </div>
                  <div className="my-2">
                    <label>Billing Address:</label>
                    <p className="muted-text">
                      {singleClinicData?.street_address_1},
                      <br />
                      {singleClinicData?.city}({singleClinicData?.state})
                    </p>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div>
                    <label>Contract</label>
                    {clinicData?.contract_file ? (
                      <a
                        target="_blank"
                        href={clinicData?.contract_file}
                        style={{
                          color: "#94a3b8",
                          userSelect: "none",
                          cursor: "pointer",
                        }}
                      >
                        Download Contract File
                      </a>
                    ) : (
                      <>
                        <span className="muted-text">No Contract attached</span>
                        <input
                          type="file"
                          ref={uploadContractInput}
                          onChange={handleContractUpload}
                          hidden={true}
                        />
                        <button
                          className="alternative-btn btn d-flex"
                          style={{
                            gap: "10px",
                            alignContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            uploadContractInput?.current?.click();
                          }}
                        >
                          <PlusCircle
                            fill="#333"
                            style={{ marginRight: "4px", marginTop: "-2px" }}
                          />{" "}
                          Upload Contract
                        </button>
                      </>
                    )}

                    <div>
                      <div className="d-flex my-3" style={{ gap: "10px" }}>
                        <label className="switch-small">
                          <input
                            disabled={false}
                            onChange={() => {
                              setIsTestAccount(!isTestAccount);
                            }}
                            checked={isTestAccount}
                            type="checkbox"
                          />
                          <span className="slider-small round"></span>
                        </label>
                        <span className="muted-text">Is Test Account?</span>
                      </div>
                      <div className="d-flex" style={{ gap: "10px" }}>
                        <label className="switch-small">
                          <input
                            disabled={false}
                            onChange={() => {
                              setAutoCCPayment(!autoCCMode);
                            }}
                            checked={autoCCMode}
                            type="checkbox"
                          />
                          <span className="slider-small round"></span>
                        </label>
                        <span className="muted-text">Auto CC Payment</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardLayout>

            <div
              className="container-fluid px-1 py-4 row my-3"
              style={{ margin: "0px" }}
            >
              <div
                className="col-sm-12 col-md-3 col-lg-3"
                style={{ margin: "0px", padding: "0px" }}
              >
                <InfoCard
                  title={"Created On"}
                  stats={
                    moment(singleClinicData?.created).format("MM/DD/YYYY") ||
                    "Not Specified"
                  }
                  information={"Created on this date"}
                  show_link={false}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"Clinics"}
                  stats={relatedClinics?.length || "0"}
                  information={"Number of clinics managed by this group"}
                  show_link={false}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"Payment Method"}
                  stats={clinicData?.payment_type || "Add Payment Method"}
                  information={"Payment method for this clinic group"}
                  show_link={false}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <InfoCard
                  title={"Type"}
                  stats={clinicData?.type || "Not Specified"}
                  information={"Type of this healthcare / clinic group"}
                  show_link={false}
                />
              </div>
            </div>

            <div className="row mt-4">
              <CardLayout
                className="col-sm-12 col-md-6 col-lg-6"
                style={{
                  border: "5px solid transparent",
                  boxSizing: "border-box",
                  backgroundClip: "padding-box",
                }}
              >
                <div className="container-fluid">
                  <div className="d-flex justify-content-between my-3">
                    <h6 className="info-card-title">
                      <strong style={{ fontSize: "1.2rem" }}>Clinics</strong>
                    </h6>

                    <small>
                      <Link
                        to="/ops/clinics/all"
                        style={{
                          textDecoration: "underline",
                          color: "#3893CC",
                          fontWeight: "bold",
                        }}
                      >
                        View All
                      </Link>
                    </small>
                  </div>
                  {relatedClinics?.length === 0 && (
                    <NoPatients text={"There are no clinics"} />
                  )}
                  {relatedClinics?.length > 0 && (
                    <>
                      <ClinicsTable data={relatedClinics?.slice(0, 5)} />
                      <br />
                    </>
                  )}
                </div>
              </CardLayout>
              <CardLayout
                className="col-sm-12 col-md-6 col-lg-6"
                style={{
                  border: "5px solid transparent",
                  boxSizing: "border-box",
                  backgroundClip: "padding-box",
                }}
              >
                <div className="container-fluid">
                  <div className="d-flex justify-content-between my-3">
                    <h6 className="info-card-title">
                      <strong style={{ fontSize: "1.2rem" }}>
                        Invoicing History
                      </strong>
                    </h6>

                    <small>
                      <Link
                        to="#"
                        style={{
                          textDecoration: "underline",
                          color: "#3893CC",
                          fontWeight: "bold",
                        }}
                      >
                        View All
                      </Link>
                    </small>
                  </div>
                  {clinicData?.invoicing_history &&
                    clinicData?.invoicing_history?.length === 0 && (
                      <NoPatients text={"There is no invoicing history yet!"} />
                    )}
                  {clinicData?.invoicing_history &&
                    clinicData?.invoicing_history?.length > 0 && (
                      <>
                        <InvoicingHisotryTable
                          data={clinicData?.invoicing_history?.slice(0, 5)}
                        />
                        <br />
                      </>
                    )}
                </div>
              </CardLayout>
            </div>

            <CardLayout className="my-4 p-3">
              <div className="d-flex container-fluid w-100">
                <h3 className="primary-text-blue">Notes</h3>
              </div>
              <textarea
                onInput={(e) => {
                  setNotes(e.target.value);
                }}
                value={notes}
                rows="7"
                placeholder="Manually entered Setup Fee to client and set to $0 in system so that we don't accidentally double charge. (MSB 1/4/22)"
                className="form-control"
              ></textarea>
              <div className="mb-2 container-fluid d-flex justify-content-end">
                <button className="primary-btn">Update</button>
              </div>
            </CardLayout>
          </>
        )}
      </section>
    </SidebarLayout>
  );
};

export default SingleClinic;
